import { Action, createReducer, on } from '@ngrx/store';
import { screenActions } from './screen-store.action';
import { ScreenState, screenIS } from './screen-store.state';

const screenRegister = createReducer(
  screenIS,
  on(screenActions.setScreenIdAction, (state, { id }) => ({
    ...state,
    info: {
      ...state.info,
      id,
    },
  })),

  on(screenActions.setScreenTitleAction, (state, { title }) => ({
    ...state,
    info: {
      ...state.info,
      title,
    },
  })),

  on(screenActions.setScreenCompanyAction, (state, { company }) => ({
    ...state,
    info: {
      ...state.info,
      company,
    },
  })),

  on(screenActions.setScreenLoadingAction, (state, { loading }) => ({
    ...state,
    loading,
  })),

  on(screenActions.setAllDefaultAction, () => screenIS),

  on(screenActions.setScreenShowHeadingAction, (state, { showHeading }) => ({
    ...state,
    showHeading,
  }))
);

export function screenReducer(state: ScreenState, action: Action): any {
  return screenRegister(state, action);
}
